import { ActivatedRouteSnapshot } from '@angular/router';
import { SerializedRouterStateSnapshot } from '@ngrx/router-store';

/**
 * This function returns all route parameters from the router state.
 *
 * @param snapshot SerializedRouterStateSnapshot
 * @returns {Object} The route parameters from the router state.
 */
export const getAllRouteParameters = (
  snapshot: SerializedRouterStateSnapshot,
) => {
  let route = snapshot.root;
  const params = new Map(
    Object.keys(route.params).map((key) => [key, route.params[key]]),
  );
  while (route.firstChild) {
    route = route.firstChild;
    Object.keys(route.params).forEach((key) =>
      params.set(key, route.params[key]),
    );
  }
  return params;
};

/**
 * This function returns all query parameters from the router state.
 *
 * @param snapshot SerializedRouterStateSnapshot
 * @returns {Object} The query parameters from the router state.
 */
export const getAllQueryParameters = (
  snapshot: SerializedRouterStateSnapshot,
) => {
  let route: ActivatedRouteSnapshot = snapshot.root || snapshot;
  const params = new Map(
    Object.keys(route.queryParams).map((key) => [key, route.queryParams[key]]),
  );
  while (route.firstChild) {
    route = route.firstChild;
    Object.keys(route.queryParams).forEach((key) =>
      params.set(key, route.queryParams[key]),
    );
  }

  return params;
};
